import React from 'react';

const experiences = [
    {
        date: 'Now',
        title: 'Software Engineer',
        company: 'UhuruTek Solutions',
        overview: [
            'Participating in daily stand-up meetings to report progress and plan work for the day',
            'Breaking down complex features into smaller, more manageable tasks',
            'Developing and testing code within the time frame of a sprint (usually 1-4 weeks)',
            'Developed portal frontend application for an AI chat app using Next.js',
            'Developed Node.js integration with OpenAI`s GPT-3.5 for conversation'

        ],
    },
    {
        date: 'September 2023',
        title: 'Software Developer',
        company: 'shurjoMukhi Limited',
        overview: [
            'Working closely with CTO in order to build a solid team around and ensure delivery capabilities',
            'Developed backend for Ansar registration and requirement system',
            'Developed shurjoPay node js package for seamless payment integration',
            'Developed frontend for BUET alumni management portal',
            'Managed Git repositories, reducing code conflicts and enhancing collaboration'
        ],
    },
    {
        date: 'October 2022',
        title: '',
        company: '',
    },
];

const Experience = () => {
    return (
        <>
            <h2>
                <span className='text-blue-500'>E</span>xperience
            </h2>
            <hr className="my-4" />

            <ol className="relative border-l border-gray-200 dark:border-gray-700">
                {experiences.map((experience, index) => (
                    <li key={index} className="mb-4 ml-4">
                        <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
                        {experience.date && (
                            <time className="mb-1 font-normal leading-none text-blue-400">{experience.date}</time>
                        )}
                        {experience.title && (
                            <h3 className="text-lg font-semibold text-gray-800 pt-1">{experience.title}</h3>
                        )}
                        {experience.company && (
                            <p className="text-base mb-4 font-normal text-gray-700 dark:text-gray-500">{experience.company}</p>
                        )}
                        {experience.overview && (<ul className='text-sm text-gray-500 '>
                            {experience.overview.map((item, idx) => (
                                <li key={idx}>• {item}</li>
                            ))}
                        </ul>
                        )}
                    </li>
                ))}
            </ol>
            <br />
        </>
    );
};

export default Experience;
